<template>
  <div class="containertop-register">
    <nav-bar
      :title="'創建帳戶'"
      :isFixed="true"
      :goBack="goBack"
      :bgc="'background: rgba(224, 239, 201)'"
    ></nav-bar>
    <div class="bg"></div>
    <div
      v-if="isCaptchaNew"
      :class="['register-form headerTop']"
    >
      <van-form @submit="onSubmit">
        <div class="label" style="margin-top: 0;">
          {{ $t("診所名稱") }} 
        </div>
        <van-field v-model="params.userName" :placeholder="$t('診所名稱')" />
        <div class="error" v-if="verifyobj.userName">
          {{ $t("请填写診所名稱") }}
        </div>
        <div class="label">
          {{ $t("電話號碼") }}
          
        </div>
         <div class="AddressList m12" @click="show=true">
          <div :style="phoneLabel ? 'color:#1A1A1A;' : ''">
            {{ phoneLabel ? phoneLabel : $t("區號") }}
          </div>
          <img src="@/assets/icons/arrow-rightactive.png" alt="" />
        </div>
        <van-field
          v-model="params.phone"
          type="text"
          :placeholder="$t('電話號碼')"
        />
        <div class="error" v-if="(verifyobj.phoneregx || verifyobj.phone)">
          {{ $t("請輸入") }}
          {{ $t("有效電話號碼") }}
        </div>
           <div class="label">
          {{$t("電子郵箱地址") }}
          
        </div>
        <van-field
          v-model="params.email"
          type="text"
          :placeholder="$t('電子郵箱地址')"
        />

        <div class="error" v-if="(verifyobj.email || verifyobj.emailregx)">
          {{ $t("請輸入") }}
          {{ $t("有效電子郵箱地址") }}
        </div>


     

        <div class="label">{{ $t("姓名") }} </div>
        <van-field v-model="params.name" :placeholder="$t('姓名')" />
        <div class="error" v-if="verifyobj.name">
          {{ $t("請輸入") }} {{ $t("姓名") }}
        </div>

        <div class="label">
          {{ $t("診所地址") }} 
        </div>
        <div class="AddressList" @click="openAddressDialog">
          <div :style="selectTitle ? 'color:#1A1A1A;' : ''">
            {{ selectTitle ? selectTitle : $t("所在地區") }}
          </div>
          <img src="@/assets/icons/arrow-rightactive.png" alt="" />
        </div>
        <div class="error" v-if="verifyobj.province" style="margin-top: 6px;">
          {{ $t("請選擇") }} {{ $t("所在地區") }}
        </div>
        <van-field
          style="margin-bottom: 12px;margin-top: 12px;"
          v-model="params.street"
          :placeholder="$t('大廈/屋苑&街道')"
        />
         <div class="error" v-if="verifyobj.street" style="margin-top: 6px;">
          {{ $t("請輸入") }} {{ $t("大廈/屋苑&街道") }}
        </div>
        <van-field v-model="params.address" :placeholder="$t('單位&樓層')" />
         <div class="error" v-if="verifyobj.address" style="margin-top: 6px;">
          {{ $t("請輸入") }} {{ $t("單位&樓層") }}
        </div>
        <div class="label">
          {{ $t("商業登記證") }} 
        </div>

        <van-uploader
          :max-count="1"
          :before-read="beforeRead"
          :after-read="afterRead"
          v-model="fileList"
          preview-size="100%"
        >
          <template #default>
            <div v-if="!loading2">
              <img
                v-if="langEnv == 2"
                src="@/assets/image/user/uploaden.png"
                alt=""
              />
              <img v-else src="@/assets/image/user/uploadzh.png" alt="" />
            </div>
            <van-loading style="width: 100%;height: 100%;" v-if="loading2">

        </van-loading>
          </template>
        </van-uploader>
        <div class="error" v-if="verifyobj.businessLicense">
          {{ $t("请填写") }} {{ $t("商業登記證") }}
        </div>


 
        <div style="margin: 12px 0;">
          <van-button color="#90D12E" block type="primary" native-type="submit">
            {{ $t('提交') }}
          </van-button>
        </div>

      </van-form>
    </div>
    <div class="email-CaptchaNew" v-else>
      <div class="CaptchaNew-title">
        {{ type==='email'?$t("爲了驗證您的電子郵件，我們將向您發送一個驗證碼，請查收后輸入"):$t("爲了驗證您的電話號碼，我們將向您發送一個驗證碼，請查收后輸入") }}
      </div>
      <van-field
        v-model="CaptchaNewCode"
        :placeholder="$t(type==='email'?'請輸入郵箱驗證碼':'請輸入電話驗證碼')"
      />
      <div class="get-CaptchaNew" v-if="countDown !== 0">
        {{ countDown }}s，{{ $t("再次獲取驗證碼") }}
      </div>
      <div class="get-CaptchaNew" v-else @click="getEmailCode('2')">
        {{ $t("獲取驗證碼") }}
      </div>
      <van-button
        :loading="loading"
        class="get-CaptchaNew-btn"
        @click="getSubmitRegister"
      >
        {{ $t("確認") }}</van-button
      >
    </div>
    <addressCascader
      :isShow="isShow"
      @handleClose="handleClose"
      @handleAreaCode="handleAreaCode"
    ></addressCascader>
    <van-popup
      v-model:show="show"
      position="bottom"
      :close-on-click-overlay="false"
      :style="{ height: '40%', borderRadius: '16px 16px 0 0' }"
    >
      <div class="titleArea">
        <div></div>
        <div>{{$t('國家地區')}}</div>
        <div class="close">
          <img
            @click="show = false"
            style="width: 100%"
            src="@/assets/icons/ic_Close@2x.png"
            alt=""
          />
        </div>
      </div>
      <div class="phone-list">
        <div
          :class="['phone-item', { actvie: item.code == params.areaCode }]"
          v-for="item in phoneCode"
          :key="item.code"
          @click="handleAreaCode2(item)"
        >
          <div class="phone-text">{{ item.name }}</div>
          <img
            class="phone-check"
            v-if="item.code == params.areaCode"
            src="@/assets/icons/check.png"
            alt=""
          />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import JSEncrypt from "jsencrypt";
import heic2any from "heic2any";
import { getCaptchaNew, getvalidateEmail, getRegisterNew,validatePhone } from "@/api/user";
import { setToken } from "@/utils/token.js";
import mixins from "@/utils/mixins.js";
import { mapState } from "vuex";
export default {
  beforeRouteEnter(to, form, next) {
    if (form.path.includes("about")) {
      to.query.isCache = true;
    }
    next();
  },
  mixins: [mixins],
  data() {
    return {
      fileList: [],
      form: {
        userName: "",
        password: "a123456",
        captcha: ""
      },
      show:false,
      phoneLabel:'',
      params: {
        userName: "",
        password: "a123456",
        email: "",
        platform: 4,
        name: "",
        address: "",
        captcha: "",
        phone: "",
        province: "",
        city: "",
        district: "",
        street: "",
        businessLicense: "",
        areaCode: "",
        invitationCode: ""
      },
      active: "1",
      isPassword: true,
      isEmail: false,
      isEyes: false,
      AddressList: [],
      isShow: false,
      selectTitle: "",
      checked: false,
      verifyobj: {
        userName: "",
        password: "",
        name: "",
        email: "",
        businessLicense: "",
        province: "",
        address: "",
        street: "",
        phone:""
      },
      verifyList: [],
      isRegister: false,
      isCaptchaNew: true,
      CaptchaNewCode: "RITH123",
      countDown: 60,
      loading: false,
      loading2: false,
      type: "email",
      langEnv: ""
    };
  },
  computed: {
    ...mapState("user", ["registerForm", "cacheFileList","phoneCode"])
  },
  watch: {
    params: {
      deep: true,
      async handler(val) {
        try {
          this.$store.dispatch("user/getregisterForm", this.params);
          this.$store.dispatch("user/getFileList", this.fileList);
        } catch (error) {}
      }
    }
  },
  async created() {
    console.log(this.$route);
    await this.$store.dispatch("user/getPhoneCode");
    this.params.areaCode=this.phoneCode[0]?.code;
    this.phoneLabel=this.phoneCode[0]?.name;
    this.langEnv = window.localStorage.getItem("langEnv");
    if (this.$route.query.isCache) {
      this.params = { ...this.registerForm };
      this.fileList = this.cacheFileList;
      this.selectTitle = `${this.params.province.split("●")[1]||''}${
        this.params?.city?.split("●")[1]
          ? "/" + this.params?.city?.split("●")[1]
          : ""
      }${
        this.params?.district?.split("●")[1]
          ? "/" + this.params?.district?.split("●")[1]
          : ""
      }`;
    }
    console.log(this.fileList);

    // this.getAddressList();
  },

  methods: {
    getTime() {
      const timer = setInterval(() => {
        this.countDown--;
        if (this.countDown === 0) {
          clearInterval(timer); // 清除定时器
          this.countDown = 0;
        }
      }, 1000);
    },
    handleAreaCode2(item) {
      this.show = false;
      this.params.areaCode = item.code;
      this.phoneLabel = item.name;
    },
    goBack() {
      if (!this.isCaptchaNew) {
        this.isCaptchaNew = true;
      } else {
        this.$router.back();
      }
    },
    gotoRegister() {
      this.isRegister = false;
      this.checked = true;
    },
   compressImg(fileObj) {
  return new Promise((resolve, reject) => {
    let quality = 0.99;
    let reader = new FileReader();
    reader.readAsDataURL(fileObj);
    reader.onload = function(e) {
      let image = new Image();
      image.src = e.target.result;
      image.onload = function() {
        let canvas = document.createElement('canvas');
        let context = canvas.getContext('2d');
        let imageWidth = image.width / 2;
        let imageHeight = image.height / 2;
        canvas.width = imageWidth;
        canvas.height = imageHeight;
        
        context.drawImage(image, 0, 0, imageWidth, imageHeight);
        let data = canvas.toDataURL('image/jpg', quality);
        while (data.length / 1024 / 1024 > 5) {
          quality -= 0.03;
          context.clearRect(0, 0, canvas.width, canvas.height); // 清空画布
          context.drawImage(image, 0, 0, canvas.width, canvas.height); // 重新绘制图像
          data = canvas.toDataURL("image/jpeg", quality); // 重新生成数据URL
        }

        canvas.toBlob(function(blob) {
          const f = new File([blob], fileObj.name, { type: 'image/jpeg' });
          resolve(f);
        }, 'image/jpeg');
      };
      image.onerror = function() {
        reject(new Error("Image loading error"));
      };
    };
    reader.onerror = function() {
      reject(new Error("File reading error"));
    };
  });
},

async beforeRead(file) {
  console.log(file.type);
  const maxSize = 5 * 1024 * 1024;
  this.loading2=true;
  // 文件类型检查
  // if (!file.type?.includes('image')) {
  //   this.loading2=false;
  //   this.$toast("请上传图片");
  //   return false;
  // }

    if (file.type?.includes('heic')) {
      const resultBlob = await heic2any({
                    blob: file,
                    toType: "image/jpeg"
          });
           file = new File([resultBlob], 'newFileName.' + file.name.split('.').pop(), { type: file.type });
    }
    return this.compressImg(file)
      .then(compressedFile => {
        return compressedFile; // 返回压缩后的文件
      })
      .catch(err => {
        console.error(err);
        this.loading2=false;
        return false; // 处理错误情况
      });
  
  
},
    validatoFormFormcheck(label) {
      if (!this.params[label]) {
        this.verifyList.push(label);
      } else {
        const index = this.verifyList.findIndex(item => item === label);
        if (index != -1) {
          this.verifyList.splice(index, 1);
        }
      }
    },
    validatoForm() {
      for (const key in this.verifyobj) {
        this.verifyobj[key] = "";
      }
      this.verifyList.forEach(item => {
        this.verifyobj[item] = true;
      });
    },
    gotoLogin() {
      this.$router.push("/login");
    },
    afterRead(file) {
      this.params.businessLicense = file.file;
      console.log(file);
      this.loading2 = false;
       this.$nextTick(() => {
        this.fileList=[{...file,isImage:true}]
      });
    },
    handleAreaCode(data) {
      const areaList = data.filter(item => item.value !== "1");
      areaList.forEach((item, index) => {
        if (index === 0) {
          this.params.province = item.value + "●" + item.label;
        } else if (index === 1) {
          this.params.city = item.value + "●" + item.label;
        } else if (index === 2) {
          this.params.district = item.value + "●" + item.label;
        }
      });
      const res = areaList.map(items => items.label).join("/");
      this.selectTitle = res;
      console.log(this.params);
    },
    async getEmailCode(type) {
      const publicKey = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC/TS09a8Uez9/XfkDdK+Exx3ltVxrUlCjNPqRheMB/63iHyjx5k+N/48Nh9NFdCQKLEV/WxHQoszEBEh/sFofQuAx1wB9bcOtD98DT8Wkd53XmojxVfhtsVjeI/IBMim56mrO/LcKQDwc/6BsbFvilde002wx3CQ91OCw8XMptTwIDAQAB`;
      let obj=this.type==='email'?{
        email: this.params.email,
        type: "register",
        captcha: ""
      }:{
        phone: this.params.phone,
        type: "register",
        areaCode: this.params.areaCode,
        captcha: ""
      }
      let jsEncrypt = new JSEncrypt();
      jsEncrypt.setPublicKey(publicKey);
      let dataToEncrypt = JSON.stringify(obj);
      console.log(dataToEncrypt);
      const res = await getCaptchaNew({
        id: jsEncrypt.encrypt(dataToEncrypt)
      });
      if (type == "2") {
        this.countDown = 60;
        this.getTime();
      }
    },
    async onSubmit() {
      const regxEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      const regx = /^(?=.*\d)(?=.*[a-zA-Z]).+$/;
      let regxPhone = /^1[3456789]\d{9}$/;
      switch (this.params.areaCode) {
         case '+852': // 香港
            regxPhone = /^(?:\+852)?[0-9]{8}$/;
                break;
            case '+86': // 中国大陆
                regxPhone = /^(?:\+86)?1[3-9][0-9]{9}$/; // 11位手机号，以1开头
                break;
            case '+1': // 美国/加拿大
                regxPhone = /^(?:\+1)?[0-9]{10}$/; // 10位手机号
                break;
            case '+853': // 澳门
                regxPhone = /^(?:\+853)?[0-9]{8}$/; // 8位手机号
                break;
            // 可以添加其他国家的区号和对应的正则表达式
            default:
                regxPhone = /^(?:\+852)?[0-9]{8}$/;
      }
      this.verifyList = [];

      if (!regxEmail.test(this.params.email)) {
        this.verifyobj["emailregx"] = true;
      } else {
        delete this.verifyobj["emailregx"];
      }
      if (!regxPhone.test(this.params.phone)) {
        console.log(7);
        this.verifyobj["phoneregx"] = true;
      }else{
        delete this.verifyobj["phoneregx"];
      }
    
      const keys = Object.keys(this.verifyobj);
      keys.forEach(item => {
        this.validatoFormFormcheck(item);
      });

      this.validatoForm();
   console.log(this.verifyList);
   console.log(this.verifyobj);
   if (!this.verifyobj.phone&&!this.verifyobj.phoneregx||!this.verifyobj.email&&!this.verifyobj.emailregx) {
       if (!this.verifyobj.phone&&!this.verifyobj.phoneregx) {
            this.verifyobj.email=''
            this.verifyobj.emailregx=''
            this.verifyList=this.verifyList.filter(item=>item!=='email'&&item!=='emailregx')
       }else if (!this.verifyobj.email&&!this.verifyobj.emailregx) {
              this.verifyobj.phone=''
            this.verifyobj.phoneregx=''
            this.verifyList=this.verifyList.filter(item=>item!=='phone'&&item!=='phoneregx')
       }
   }
      if (this.verifyList.length > 0) {
        return;
      }
      let res =null
      let r=null
      if (this.params.email) {
        res = await getvalidateEmail({ email: this.params.email });
      }
      if(this.params.phone){
        res = await validatePhone({phone:this.params.phone,areaCode:this.params.areaCode});
      }
      if (res&&res.resultID !== 1200||r&&r.resultID !== 1200) {
        // 邮箱已存在
        this.$toast(res.resultID !== 1200?res.message:r.message);
        return 
      } else {
        this.getSubmitRegister()
      }

      console.log(this.verifyobj);
      console.log(this.verifyList);
    },
    async getSubmitRegister() {
      this.params.captcha = this.CaptchaNewCode;
      if (this.$route.query.invitationCode) {
        this.params.invitationCode = this.$route.query.invitationCode;
      }

      let formData = new FormData();
      Object.entries({ ...this.params }).forEach(([key, value]) => {
        formData.append(key, value);
      });

      // formData.append("businessLicense", this.params.businessLicense);
      this.loading = true;
      const res = await getRegisterNew(formData);

      if (res.resultID === 1200) {
        this.$toast(res.message);
        this.params=  {
            userName: "",
            password: "a123456",
            email: "",
            platform: 4,
            name: "",
            address: "",
            captcha: "",
            phone: "",
            province: "",
            city: "",
            district: "",
            street: "",
            businessLicense: "",
            areaCode: "",
            invitationCode: ""
        }
         this.params.areaCode=this.phoneCode[0]?.code;
        this.phoneLabel=this.phoneCode[0]?.name;
        this.fileList=[]
        this.selectTitle='';
      }else{
        this.$toast(res.message);
      }
        this.loading = false;
    },
    openAddressDialog() {
      this.isShow = true;
    },
    handleClose(data) {
      this.isShow = false;
    }
  }
};
</script>

<style lang="scss">
.containertop-register {
  .email-CaptchaNew {
    padding: 40px 26px;
    .CaptchaNew-title {
      font-size: 15px;
      color: #666666;
      line-height: 24px;
      margin-bottom: 24px;
    }
    .get-CaptchaNew {
      text-align: center;
      padding: 10px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #d2edab;
      color: #bce382;
      margin-bottom: 40px;
    }
    .get-CaptchaNew-btn {
      width: 100%;
      background: #90d12e;
      border-radius: 8px 8px 8px 8px;
      color: #fff;
    }
  }
  .bg {
    position: fixed;
    z-index: 0;
    width: 100%;
    height: 148px;
    background: linear-gradient( 180deg, rgba(144,209,46,0.3) 0%, rgba(144,209,46,0) 100%);
    border-radius: 0px 0px 0px 0px;
  }

  .logo {
    width: 166px;
    margin: 46px 0 40px 32px;
  }
  .register-form {
    padding: 24px;
    padding-bottom: 53px;
    .label {
      margin-bottom: 12px;
      font-weight: 500;
      font-size: 17px;
      color: #1a1a1a;
      line-height: 24px;
      margin-top: 24px;
    }
    .van-checkbox {
      align-items: start;
      .van-checkbox__icon {
        margin-top: 3px;
        .van-badge__wrapper {
          border-radius: 2px;
        }
      }
    }
    .agree {
      font-size: 14px;
      .agree-text {
        color: #90d12e;
      }
    }
    .van-uploader,
    .van-uploader__input-wrapper {
      width: 100%;
      .van-uploader__preview-image {
        height: 216px !important;
        object-fit: cover;
      }
      .van-loading {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 216px !important;
      }
    }
    .van-button {
      border-radius: 12px;
    }
    .error {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #f82207;
      line-height: 18px;
      padding-left: 12px;
      margin-top: 1px;
    }
  }
  .verify {
    color: #f82207;
  }
  .van-field {
    background-color: #fff;
    border-radius: 12px 12px 12px 12px;
    border: 1px solid #ebebeb;
    margin-bottom: 12px;
    padding: 16px;
    .van-field__control {
      font-size: 16px;

      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;

      &::placeholder {
        color: #999999;
      }
    }
  }
  .m12{
    margin-bottom: 12px;
  }
  .van-tabs {
    width: 60%;
  }
  .van-tabs__nav {
    background-color: transparent;
    height: auto;
    .van-tabs__line {
      display: none;
    }
    .van-tab:first-child {
      border-right: 1px solid #bdbdbd;
    }
    .van-tab__text {
      font-size: 18px;
    }
  }
  .arrow {
    width: 16px;
    height: 16px;
  }
  .phone {
    display: flex;
    align-items: center;
    font-size: 15px;
    color: #1a1a1a;
    margin: 12px 0px 20px 14px;
  }
  .login-form {
    padding: 0 22px;
  }
}
.Forgot {
  display: flex;
  justify-content: end;
  font-size: 15px;
  color: #1a1a1a;
  line-height: 24px;
  margin-top: 20px;
}
.register {
  text-align: center;
  color: #90d12e;
}
.AddressList {
  position: relative;
  z-index: 2;
  width: 100%;
  border-radius: 12px 12px 12px 12px;
  border: 1px solid #ebebeb;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #999999;
  font-size: 16px;
  background-color: #fff;
  // margin-bottom: 6px;
  img {
    width: 20px;
  }
}
.register-dialog {
  padding: 24px;
}
.register-text {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #666666;
  line-height: 24px;
  text-align: center;
  span {
    color: #3491fa;
  }
}
.register-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .Cancel,
  .Confirm {
    flex: 1;
    text-align: center;
    margin-top: 32px;
  }
  .Cancel {
    background: #eeeeee;
    border-radius: 12px 12px 12px 12px;
    padding: 8px;
    margin-right: 12px;
  }
  .Confirm {
    font-size: 16px;
    color: #ffffff;
    background-color: #90d12e;
    border-radius: 12px 12px 12px 12px;
    padding: 8px;
  }
}
.switch-bar{
  display: flex;
  align-items: center;
  margin-top: 8px;
  border-bottom: 1px solid #EBEBEB;
  font-size: 15px;
  position: relative;
  .switch-item {
    flex: 1;
    text-align: center;
    font-size: 15px;
    color: #666666;
    line-height: 24px;
    height: 44px;
    line-height: 44px;
  }
  .active-item{
    color: #90d12e;
  }
  .active-bar{
    position: absolute;
    width: 28px;
    height: 4px;
    border-radius: 2px;
    background-color: #90d12e;
    bottom: 0;
    transform: translateX(calc(25vw - 14px));
  }
  .active-bar2{
    position: absolute;
    width: 28px;
    height: 4px;
    border-radius: 2px;
    background-color: #90d12e;
    bottom: 0;
    transform: translateX(calc(75vw - 14px));
  }
}
.phone-list {
  padding: 20px 16px;
  .actvie {
    border: 2px solid #90d12e !important;
  }
  .phone-item {
    padding: 20px;
    position: relative;
    background: #f8f8f8;
    border-radius: 8px 8px 8px 8px;
    margin-bottom: 12px;
    border: 2px solid transparent;
    .phone-text {
      font-size: 16px;
      color: #1a1a1a;
      line-height: 16px;
      text-align: center;
    }
    .phone-check {
      position: absolute;
      width: 24px;
      bottom: -1px;
      right: -1px;
    }
  }
}
.titleArea {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 16px 0;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 17px;
  color: rgba(0, 0, 0, 0.9);
  line-height: 24px;

  .close {
    width: 20px;
  }
}
.header-container{
    img{
        display: none;
    }
}
</style>
